<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zSDp4L/media/FC-9781398430716.jpg?1684514527374" alt="This image is the cover for the book Devil's Bin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Devil's Bin
      </h1>
      <p class="bookDescription body article font2">
        <p>This book is about a young woman who was looking for an adventure after ending a relationship. She decided on a Canadian trekking trip in the Northern Territories in mid-winter. Her friend was going to go with her but backed out at the last minute, leaving her to go on her own. On the plane, she met up with two guys who were also going trekking and offered her a lift from the hotel to the trail. They set off together but separated half way up, leaving Valeria on her own to continue after taking a rest. As she continued up the trail, she came to a fork, but it wasn’t on the map; there weren’t any signs so she decided to go right, but the snow kept getting deeper, and she couldn’t see where she was walking. She carried on a bit further but then lost her footing and fell into a small ravine. She couldn’t pull herself out and feared the worst. In desperation, as the light was fading, she screamed as loud as she could until finally she heard the crunch of the snow above in the hope it was human. What transpires is nothing like she imagined her trip to be. Devil’s Bin takes you on a journey of love, sex, loss and other complexities of life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lysette Maison
      </h2>
      
      <p class="authorDescription body article">Lysette Maison is a mother of two and grandmother of three. After retiring from the NHS as a medical secretary, she took a long vacation, travelling to various countries, which inspired her to write her books. Her first book, Invisible Liaison, was set in Syria, India and America. Her second book, Devil’s Bin, is set in Yellowknife in the Northern Territories of Canada. Visiting these countries inspired her to write the stories and give an accurate account of the environment in which they are based. Her next book, Red Scarab, which she is working on at present, is set in Egypt and England. Lysette is a passionate writer and writes from the heart, which makes for interesting yet true-to-life stories people can relate to.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03fb13d7